export default "<dual-list [source]=\"source\" [(destination)]=\"destination\" [format]=\"format\" [height]=\"300\"></dual-list>\r\n";